import GeneButton from "../GeneButton";

export default function GeneButtonList({genes, styleProps}) {
    return (
        <div style={{display: 'flex', flexWrap: 'wrap'}}>
            {genes?.map((gene, index) => {
                const countOfGene = genes?.length;
                const gene_info = gene?.trim().split(" ")[0];
                return (
                    <GeneButton styleProps={styleProps} text={gene_info} isDot={index !== (countOfGene - 1)}/>
                )
            })}
        </div>
    )
}